import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Triangle and rectangle sharing an edge:
 * Triangle edge AB = Rectangle bottom edge (exterior — triangle below rectangle).
 *
 * Uses EdgeTarget: t1's edge AB is aligned to r1's bottom edge (exterior side).
 * The triangle's c param matches r1's width (8) so edges align.
 */
export const SHARED_EDGE_PRESET: GeometryPadWidgetConfig = {
  id: 'shared-edge',
  type: 'geometrypad',
  params: {
    elements: {
      r1: {
        type: 'Rectangle',
        params: { w: 8, h: 5 },
      },
      t1: {
        type: 'Triangle',
        params: {
          a: 6,
          b: 7,
          c: 8,
          AB: { ref: 'r1.edge.bottom', side: 'exterior' },
        },
      },
    },
  },
  display: {
    geometry: {
      label: { coloring: true },
    },
  },
};
